import { render } from "./LockIcon.vue?vue&type=template&id=3d1a5dc3"
const script = {}
script.render = render

export default script